module.exports = __webpack_public_path__ + "static/BerberBlock2-c6a2ca0a28ed2a55ee0326c1a77b0852.jpg";